export const exhaustSwitchCase = (arg: never) => {
  throw new Error(`Switch unhandled case: ${arg}`)
}

export const exhaustSwitchCaseWithFallback = <T>(_arg: never, fallback: T) => {
  return fallback
}
